import { skipToken, useQuery } from "@tanstack/react-query";
import { getPublicCampaignsCode } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import type { CampaignDto } from "Infrastructure/Api/Api";

const PUBLIC_CAMPAIGN_QUERY_KEY = "PUBLIC_CAMPAIGN";

export const publicCampaignKeys = {
  all: [PUBLIC_CAMPAIGN_QUERY_KEY] as const,
  byCode: (code?: string | null) => [...publicCampaignKeys.all, code] as const,
};

export const useCampaignByCodeQuery = (code?: string | null) =>
  useQuery<CampaignDto>({
    queryKey: publicCampaignKeys.byCode(code),
    queryFn: code
      ? processResponseWithApiProblemDetails(() => getPublicCampaignsCode(code))
      : skipToken,
    refetchOnWindowFocus: false,
  });
